module.exports = __webpack_public_path__ + "static/media/search.d3f0a601.svg";